import { Component, computed, inject, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { KENDO_DATEINPUTS } from '@progress/kendo-angular-dateinputs';
import { KENDO_FORMFIELD } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { KENDO_STACKLAYOUT } from '@progress/kendo-angular-layout';
import { ControlWrapperComponent } from '@unity/forms/composed/control-wrapper/control-wrapper.component';
import { LayoutService } from '@unity/services/layout.service';

@Component({
  selector: 'unity-selector-date-range-control',
  standalone: true,
  imports: [KENDO_FORMFIELD, KENDO_DATEINPUTS, KENDO_LABEL, KENDO_STACKLAYOUT, ReactiveFormsModule, ControlWrapperComponent],
  templateUrl: './selector-date-range-control.component.html',
  styleUrl: './selector-date-range-control.component.scss',
})
export class SelectorDateRangeControlComponent {
  private readonly layoutService = inject(LayoutService);

  protected $orientation = this.layoutService.$orientation;

  public readonly $startControl = input.required<FormControl>({ alias: 'startControl' });
  public readonly $endControl = input.required<FormControl>({ alias: 'endControl' });

  public readonly $startDisplayName = input('Start Date', { alias: 'startDisplayName' });
  public readonly $endDisplayName = input('End Date', { alias: 'endDisplayName' });
  public readonly $startDescription = input('Select a valid Start Date', { alias: 'startDescription' });
  public readonly $endDescription = input('Select a valid End Date', { alias: 'endDescription' });

  public readonly $showHint = input(true, { alias: 'showHint' });

  protected readonly $showControls = computed(() => {
    return this.$startControl().enabled && this.$endControl().enabled;
  });
}
